module.exports = __webpack_public_path__ + "static/media/laf_green.1b9e9cd5.png";